
import Vue from 'vue'
import Component from 'vue-class-component'

import { INotificationService } from '../services/NotificationService'
import UserService from '../services/UserService'
import ErrorHandlerService from '@/services/ErrorHandlerService'

import GreenButton from '../components/Atomic/GreenButton.vue'
import RedButton from '../components/Atomic/RedButton.vue'
import PasswordHelpCard from '@/components/PasswordHelpCard.vue'
import CardTitle from '@/components/Atomic/CardTitle.vue'

@Component({
  components: {
    PasswordHelpCard,
    GreenButton,
    RedButton,
    CardTitle,
  },
})
export default class ResetPassword extends Vue {
  private tokenKey!: string
  private isStudent!: boolean
  private defaultRegExp = new RegExp(
    '^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])',
    'g',
  )
  private studentRegExp = new RegExp('^(?=.{6,})', 'g')

  private $notificationService: INotificationService = {} as any
  private errorHandlerService: ErrorHandlerService = new ErrorHandlerService()

  private isPending: boolean = false

  private showNewPassword: boolean = false
  private showNewPasswordConfirmation: boolean = false
  private newPassword: string = ''
  private confirmPassword: string = ''
  private activeRegExp!: RegExp

  private created() {
    this.$validator.pause()
    this.tokenKey = this.$route.query.key as string
    if (this.tokenKey === undefined || null || '') {
      this.$router.push('/login')
    } else {
      this.isStudent =
        (this.$route.query.isStudent as string).toLowerCase() === 'true'
      this.activeRegExp = this.isStudent
        ? this.studentRegExp
        : this.defaultRegExp
    }
  }

  private async save() {
    this.isPending = true

    this.$validator.resume()
    const validated = await this.$validator.validateAll()
    if (validated) {
      try {
        await UserService.resetPassword(this.tokenKey, this.newPassword)
        this.$notificationService.success(
          this.$t('CHANGEPASSWORD.ChangeSuccess').toString(),
        )
        this.$router.push('/login')
      } catch (error: any) {
        this.errorHandlerService.handle(this, error.response.data.code, true)
      } finally {
        this.isPending = false
      }
    }
    this.$validator.pause()
    this.isPending = false
  }

  private cancel() {
    this.$router.push('/login')
  }
}
